import React from "react";
import { NavLink } from "react-router-dom";
import TypeDesign from "./../TypeDesign";

var bgimg1 = require("./../../../images/banner/web-development-banner.jpg");
var bgimg2 = require("./../../../images/background/cross-line2.png");

class ClientsLogo1 extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full  mobile-page-padding dfbb7680978 p-t80 p-b10 bg-repeat ertyuioiu1"
          style={{ backgroundImage: "url(" + bgimg1 + ")" }}
        >
          <div className="container ">
            {/* TITLE START */}
            <div className="row">
              <div className="col-md-7">
                <div className="section-head mnbv123">
                  <div className="sx-separator-outer ">
                    <div className="bg-repeat-x color-change ewgr8900">
                      <h3 className="ert678">
                        Custom E-commerce Solutions for Maximum Growth!
                      </h3>
                      <p>Leverage the power of e-commerce with a custom-designed website that boosts sales, enhances user experience, and expands your reach. Take your business online and start selling smarter today!</p>
                    </div>
                  </div>
                  <TypeDesign />
                </div>
              </div>
              <div className="col-md-5">
                <div className="mnbv1231">
                  <img
                    src={require("./../../../images/head-icon/ecom-banner.webp")}
                    alt=""
                  />
                </div>
              </div>
            </div>
            {/* TITLE END */}
          </div>
        </div>
      </>
    );
  }
}

export default ClientsLogo1;
